/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface PatientGetFormatedPhoneNumber$Params {
  HomePhone?: string | null;
  OfficePhone?: string | null;
  MobileNo?: string | null;
}

export function patientGetFormatedPhoneNumber(http: HttpClient, rootUrl: string, params?: PatientGetFormatedPhoneNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, patientGetFormatedPhoneNumber.PATH, 'get');
  if (params) {
    rb.query('HomePhone', params.HomePhone, {});
    rb.query('OfficePhone', params.OfficePhone, {});
    rb.query('MobileNo', params.MobileNo, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

patientGetFormatedPhoneNumber.PATH = '/api/Patient';
